export default "__VITE_ASSET__DphQzcd___"